import React from 'react';
import './App.css';

function App() {
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero">
        <video className="hero__background-video" autoPlay muted loop playsInline>
          <source src="tablemate_marketing_video_6.mp4" type="video/mp4" />
          {/* Fallback content if video isn't supported */}
        </video>
        <div className="hero__content">
          <h1 className="hero__headline">Tablemate Prices</h1>
          <p className="hero__subheadline">
          Hassle-free Currency Conversion Using Only Phone Camera 
          </p>
          <div className="hero__cta-container">
            <a href="https://apps.apple.com/us/app/tablemate-prices/id6739214434" className="btn btn--primary">Download on iPhone</a>
            <a href="https://play.google.com/store/apps/details?id=com.SPrasad.tablematear&hl=en" className="btn btn--secondary">Download on Android</a>
          </div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features section-padding">
        <div className="container">
          <h2 className="section-title">Seamless, Camera Based AR Currency Conversion</h2>
          <p className="section-description">
          Tablemate Prices is an innovative app that converts local currencies on menus and more to a user’s home currency while travelling abroad. 
            No more mental math, no more surprises. Shop, dine, and explore with confidence.
          </p>
          <div className="features__grid">
            <div className="feature-item">
              <h3>Instant AR Currency Overlay</h3>
              <p>Point and scan any price tag, menu, or receipt to see numbers change Infront of your eyes.</p>
            </div>
            <div className="feature-item">
              <h3>Global Currency Support</h3>
              <p>Works with all major currencies, adapting to user preferences.</p>
            </div>
            <div className="feature-item">
              <h3>Intuitive Interface</h3>
              <p>Minimal taps, maximum clarity; it’s designed to work at your pace.</p>
            </div>
          </div>
          
        </div>
      </section>

      {/* HOW IT WORKS SECTION */}
      <section className="how-it-works section-padding">
        <div className="container">
          <h2 className="section-title">Point, Scan, and Know in Seconds</h2>
          <div className="demo-video-placeholder">
            <img src="Tablemate_Marketing_Image_29.04.25_11.png" alt="Demo Video Placeholder"/>
          </div>
          <div className="how-it-works__steps">
            <div className="step"> 
              <div className="step__number">1</div>
              <h3>Point Your Camera</h3>
              <p>Open the app and hover over the item’s price.</p>
            </div>
            <div className="step">
              <div className="step__number">2</div>
              <h3>Automatic Detection</h3>
              <p>Tablemate instantly recognizes price text and applies appropriate forex rates.</p>
            </div>
            <div className="step">
              <div className="step__number">3</div>
              <h3>AR Overlay</h3>
              <p>See precise local-to-foreign cost in one seamless view.</p>
            </div>
          </div>
        </div>
      </section>

      {/* DEMO SECTION */}
      <section className="demo-section section-padding">
        <div className="container">
          <h2 className="section-title">See Tablemate in Action</h2>
          <p className="section-description">Experience the technology that’s making travelers’ lives easier around the globe.</p>
          <div className="demo-video-placeholder">
            <img src="Tablemate_Marketing_Image_29.04.25_08.png" alt="Demo Video Placeholder"/>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="testimonials section-padding">
        <div className="container">
          <h2 className="section-title">Why Travelers Love Tablemate Prices</h2>
          <div className="testimonials__grid">
            <div className="testimonial">
              <p className="testimonial__text">
                “I️ love to travel and struggle to understand how much I’m spending when I’m using a new currency! This app makes it so easy and fun to compare the prices to my home currency.”
              </p>
              <span className="testimonial__author">— Early Adopter, USA</span>
            </div>
            <div className="testimonial">
              <p className="testimonial__text">
                “Translator apps are really helpful but have always lacked this key feature of converting prices to my currency. Tablemate fills in this very crucial gap - no more mental math to figure out the price of something while I’m travelling!”
              </p>
              <span className="testimonial__author">— Beta User, UK</span>
            </div>
            <div className="testimonial">
              <p className="testimonial__text">
                “It makes shopping abroad so simple. No more confusion, no more surprises at checkout.”
              </p>
              <span className="testimonial__author">— iPhone User, AUS</span>
            </div>
          </div>
        </div>
      </section>

      {/* SECONDARY CTA SECTION */}
      <section className="cta-download section-padding">
        <div className="container">
          <h2 className="section-title">Ready to Convert Instantly?</h2>
          <p>Download the app now and see the difference real-time AR conversion makes.</p>
          <div className="hero__cta-container">
            <a href="https://apps.apple.com/us/app/tablemate-prices/id6739214434" className="btn btn--primary">Download on iPhone</a>
            <a href="https://play.google.com/store/apps/details?id=com.SPrasad.tablematear&hl=en" className="btn btn--secondary">Download on Android</a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container footer__content">
          <div className="footer__links">
            <a href="#">Privacy Policy</a> | 
            <a href="#">Terms of Use</a> | 
            <a href="tablemateprices@gmail.com">Contact Us</a>
          </div>
          <p className="footer__brandline">
            © 2025 Tablemate Prices. Travel Smarter, Spend Smarter.
          </p>
          <div className="footer__social">
            <a href="https://www.facebook.com/tablemateprices" aria-label="Facebook">FB</a>
            <a href="#" aria-label="Instagram">IG</a>
            <a href="#" aria-label="Twitter">TW</a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default App;
